"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.widgets.disabled': 'Funkcja widgetów nie jest dostępna w Twoim obecnym planie.',
};
